import classes from './NvProjectsPageProjects.module.css';
import { useState } from 'react';
import ProjectModal from './ProjectModal';
import project1 from '../../Assets/Images/project1.jpeg';
import project2 from '../../Assets/Images/project2.svg';
import project3 from '../../Assets/Images/project3.png';
import project4 from '../../Assets/Images/project4.svg';
import project5 from '../../Assets/Images/project5.svg';
import project6 from '../../Assets/Images/project6.svg';
import project7 from '../../Assets/Images/project7.png';
import project8 from '../../Assets/Images/project8.svg';
import project9 from '../../Assets/Images/project9.png';
import project10 from '../../Assets/Images/project10.svg';
import project12 from '../../Assets/Images/project12.png';
import project13 from '../../Assets/Images/project13.png';
import project14 from '../../Assets/Images/project14.png';
import project15 from '../../Assets/Images/project15.png';
import project16 from '../../Assets/Images/project16.png';
import project17 from '../../Assets/Images/project17.png';
import project18 from '../../Assets/Images/project2.svg';
import project19 from '../../Assets/Images/project19.png';
import project20 from '../../Assets/Images/project20.png';
import project21 from '../../Assets/Images/project21.png';
import project22 from '../../Assets/Images/project22.svg';
import project23 from '../../Assets/Images/project23.png';
import project24 from '../../Assets/Images/project24.png';
import project25 from '../../Assets/Images/project25.png';
import project26 from '../../Assets/Images/project26.png';
import project27 from '../../Assets/Images/project27.png';
import project28 from '../../Assets/Images/project28.png';
import search from '../../Assets/svgs/searchIcon.svg';
import downCaret from '../../Assets/svgs/downCaret.svg';
import rightArrow from '../../Assets/svgs/rightArrow.svg';
import arrow from '../../Assets/svgs/arrow.svg';

const NvProjectsPageProjects = () => {
  const projects = [
    {
      title: 'Project Rural Child Education',
      image: project1,
      location: 'Abeokuta',
      desc: 'This project aims to help to educate the kids in low-income communities with basic numearcy and literacy knowledge who have never been to schools. ',
      req: 'Basic knowledge of literacy and numeracy. Ability to communicate in local language (Yoruba)',
      side: ' Meal on arrival, Send forth party, Visit to FUNAAB zoo',
      hours: '3 weekdays and Saturday',
      duration: '2 weeks',
    },
    {
      title: 'Educating a Child',
      image: project2,
      location: 'Ife',
      desc: 'The project is aimed at setting up extracurricular activities which includes sex education, career and leadership development and debate. Equipping school students with the knowledge of these things which are crucial but are not taught in schools. ',
      req: 'Must have passion about child education, Must have basic knowledge of sex education, career and leadership development and debating.',
      side: ' Certificate of Participation, Exciting Tours, Movie Night',
      hours: 'Mon - Fri ; 7:30am - 2pm (7:30am - 1pm on Fridays)',
      duration: '2 weeks',
    },
    {
      title: 'Young Pillars',
      image: project3,
      location: 'Jos',
      desc: 'The project seeks to provide youths and children with quality education and relevant skills for growth and sustainability and the awareness to effect positive change in their environment. ',
      req: 'Passion for child education, Leadership skills',
      side: ' Get together/hangout, Certificate',
      hours: 'Mon - Fri : 9am - 4pm',
      duration: '2 weeks',
    },
    {
      title: 'Be More',
      image: project4,
      location: 'Jos',
      desc: 'The project is aimed at educating children on skills, entrepreneurship and other related areas so they are aware of vast opportunities, grow wholesomely and can gain fully contribute to world development. ',
      req: 'Passion for child education,Knowledge of a particular skill or vocation,Leadership skills',
      side: ' Get together/hangout, Certificate',
      hours: 'Mon - Fri : 3pm - 6pm; Sat : 9am - 4pm',
      duration: '2 weeks',
    },
    {
      title: 'Training Stars',
      image: project5,
      location: 'Ife',
      desc: 'This project seeks to advance SDG 4 & 6 by creating a learning space to further teach and engage the orphanage homes with curricular and extra-curricular topics i.e, entrepreneurship, digital skills, and other economically productive crafts. The project is also aimed at creating awareness about the why and how to ensure the availability and sustainable management of water and proper sanitation. ',
      req: 'Good communication skills, A teachable digital skill or craft and willingness to teach young ones ,Basic knowledge of proper sanitation, personal hygiene, career, and leadership development.',
      side: ' Certificate of Participation, Exciting Tours, Movie Night',
      hours: '3 weekdays : 3pm - 6pm; Saturday : 10am - 3pm',
      duration: '2 weeks',
    },
    {
      title: 'Educate the Next Generation',
      image: project6,
      location: 'Port Harcourt',
      desc: 'This project aims to teach to contribute and promote SD4 which is quality Education by teaching the next generation basic knowledge on economics and Information Communication Technology known as Data Processing to enhance their knowledge on it. ',
      req: 'Ability to transmit knowledge in the easiest way possible, Knowledge on Economics and Data Processing.',
      side: ' Get together/hangout, Certificate',
      hours: 'Mon - Fri : 3pm - 6pm; Sat : 9am - 4pm',
      duration: '2 weeks',
    },
    {
      title: 'Healthy Living',
      image: project7,
      location: 'Port Harcourt',
      desc: 'This project aims to teach children basic healthy habits, personal hygiene and the right measures to take when there is emergency. ',
      req: 'Passion to teach children, Basic Good Health and Well being knowledge which comprises personal hygiene tips, Healthy habits, and safety measures . ',
      side: 'First day transportation fare for all EPs, Tour, Refreshement.',
      hours: ' Monday - Friday 3pm- 5pm. Saturday  10am - 2pm',
      duration: '2 weeks',
    },
    {
      title: 'Inclusive Ed',
      image: project8,
      location: 'Enugu',
      desc: 'This project aims at increasing inclusive education for people living with disabilities by providing innovative ways of teaching them ',
      req: 'Empathy as a caregiver.   Patience. Adaptability. Practical. Dependability. ',
      side: ' Get together/hangout, Certificate',
      hours: ' Monday - Friday 3pm- 5pm. Saturday  10am - 2pm',
      duration: '2 weeks',
    },
    {
      title: 'Scale Up',
      image: project9,
      location: 'Akure',
      desc: 'The project aims to contribute to SDG #17 by building up the capacity of local NGO, non-profit organizations and/or foundations to contribute to social impact in their communities by collaborating with local social projects and engaging with grass-groot initiatives.  ',
      req: 'Adaptability. Must harbor no gender biases. Effective communication skills ',
      side: ' Get together/hangout,Certificate of participation, Movie night, Game night, Meal on arrival, Trip to Idanre hill',
      hours: ' Monday - Friday : 9am to 2pm',
      duration: '2 weeks',
    },
    {
      title: 'HIV Hotline and Counseling',
      image: project10,
      location: 'Lagos',
      desc: 'A telephone hotline project that involves receiving calls from people all over the country who need information about HIV/AIDS. The goal is to provide factual, helpful information and possibly connect them to the help they need.  it also caters to people who need counselling on how to take tests, go for checkups and more.',
      req: 'Basic knowledge of literacy and numeracy. Ability to communicate in local language (Yoruba). ',
      hours: ' Monday - Friday : 9am to 4pm',
      duration: '2 weeks',
    },
    {
      title: 'EDUTECH',
      image: project8,
      location: 'Benue',
      desc: 'This project aims at equipping primary and secondary school children aged 10 - 20 in rural areas with basic digital skills and information  to better prepare them with skills needed to compete with their counterpart in the larger society   and well contribute to national building.',
      req: 'Basic knowledge of literacy and numeracy. Ability to communicate in local language (Yoruba). ',
      hours: ' Monday - Friday : 9am to 2pm',
      duration: '2 weeks',
    },
    {
      title: 'Edify',
      image: project12,
      location: 'Enugu',
      desc: 'This project aims to provide string support for child education and promote SDG4 which is quality education ',
      req: 'Excitement to teach children, Basic literacy and numeracy knowledge',
      side: ' Hangout, Certificate, cultural experience',
      hours: ' Tuesday - Friday 8am - 2pm',
      duration: '2 weeks',
    },
    {
      title: 'VestUp',
      image: project13,
      location: 'Enugu',
      desc: 'This project aims to accomplish SDG 8 (decent work and economic growth) by facilitating clubs in schools that are about building knowledge on finance, investment and enterprenuership which would develop the financial capacity of young people. ',
      req: 'Ability to impart knowledge, Basic knowledge on entrepreneurship and finance',
      side: ' Hangout, Certificate of participation, cultural experience',
      hours: ' Tuesday - Friday 8am - 2pm',
      duration: '2 weeks',
    },
    {
      title: 'Youth Agri-Pioneers',
      image: project14,
      location: 'Enugu',
      desc: 'Seeking sustainable solutions to end hunger in all its forms and to achieve food security, improved nutrition and promote sustainable agriculture to ensure that everyone everywhere has enough good-quality food to lead a healthy life. ',
      req: 'Backround in education and agriculture',
      side: ' Hangout, Certificate of participation, cultural experience',
      hours: ' Tuesday - Friday 10am - 3pm',
      duration: '2 weeks',
    },
    {
      title:
        'Promoting accountable governance for effective service delivery (PAGES)',
      image: project15,
      location: 'Enugu',
      desc: 'This project aims to contribute to SDG #10 by promoting policies that prioritize the needs, rights, and well-being of women and youth, creating policies that effectively manage palliatives, and to pass social protection bills for women and children ',
      req: 'Background in social works will be a plus',
      side: ' Hangout, Certificate of participation, cultural experience',
      hours: ' Tuesday - Friday 10am - 3pm',
      duration: '2 weeks',
    },
    {
      title: 'For the Health of it',
      image: project16,
      location: 'Enugu',
      desc: 'This project aims to ensure healthy living and promote well-being for all ages ',
      req: 'Good communication skills, Patience',
      side: ' Hangout, Certificate of participation, cultural experience',
      hours: 'Flexible',
      duration: '2 weeks',
    },
    {
      title: 'Edurural',
      image: project17,
      location: 'Benin',
      desc: 'The project aims to ensure inclusive and equitable quality education and promote learning opportunities for members of the community especially in rural or developing areas.	 ',
      req: 'Passion for child education, Good communication skills, Adaptabilty and patience.',
      side: ' Hangout, Certificate of participation, cultural experience, Exciting Tours, Movie Night and fun.',
      hours: 'Flexible',
      duration: '2 weeks',
    },
    {
      title: 'Skill Up',
      image: project18,
      location: 'Benin',
      desc: 'The project aims to provide the opportunity for members in the community to learn a modern and in-demand skill.	 ',
      req: 'Skilled individuals who are experienced in either soft or manual skills.',
      side: ' Hangout, Certificate of participation, cultural experience, Exciting Tours, Movie Night and fun.',
      hours: 'Flexible',
      duration: '2 weeks',
    },
    {
      title: 'Building healthier communities',
      image: project19,
      location: 'Calabar',
      desc: 'The  project aims to address the challenges faced by individuals living with cancer, aligning with Sustainable Development Goal 3 Good Health and Well-being. Through a multi-faceted approach, the project seek to improve access to quality healthcare services, enhance support systems, and promote awareness and education about cancer prevention and treatment.	 ',
      req: 'Reliability and commitment,Communication skills,Passion and empathetic, physical and emotional resilience.',
      side: ' Cross-cultural experience.',
      hours: 'Flexible',
      duration: '2 weeks',
    },
    {
      title: 'Edu Innovation Hub',
      image: project20,
      location: 'Calabar',
      desc: 'The aim of this project is to substantially increase the number of young children and teenagers  who have relevant skills,  including technical and vocstionsl skill, for employment, decent jobs, and  entrepreneurship.	 ',
      req: 'Good communication skills, Ability to impact  knowledge.',
      side: ' Cross-cultural experience.',
      hours: 'Mondays - Fridays, 9am to 5pm',
      duration: '2 weeks',
    },
    {
      title: 'Teach a Child',
      image: project21,
      location: 'Benue',
      desc: 'The project aim is to provide children and young people with quality and easy access to education plus other learning opportunities, to achieve universal literacy and numeracy. A major component in acquiring knowledge and valuable skills in the learning environment.	 ',
      req: 'Good communication skills, Ability to impact  knowledge.',
      side: ' Cross-cultural experience.',
      hours: 'Mondays - Fridays, 8am to 4pm',
      duration: '2 weeks',
    },
    {
      title: 'Helping Hands',
      image: project22,
      location: 'Benue',
      desc: 'The project aims to contribute to SDG #3 by providing caregiving to sick persons in the hospital, helping in daily operation of the hospital and assisting the medical personnel in the facility with daily rountines.	 ',
      req: 'Must be in the Health Sector or studying health related  course and volunteer will be working in a clinic',
      side: ' Cross-cultural experience, Weekend Hangout',
      hours: 'Mondays - Fridays, including night shifts',
      duration: '2 weeks',
    },
    {
      title: 'Capacity strengthening workshop for changemakers',
      image: project23,
      location: 'Abuja',
      desc: 'The aim of the project is to improve the literacy and numeracy skills for young learners in public primary and secondary schools in Nigeria by enhancing the capacity of public school educators in inclusive education and 21st-century teaching methods.	 ',
      req: 'Good communication skills and volunteers, experience with either photography or videography',
      side: ' Cross-cultural experience',
      hours:
        'Monday and Wednesday,10am to 3pm,  Monday, Wednesday and Thursday, 10am to 4pm are for field work',
      duration: '2 weeks',
    },
    {
      title: 'Tech Club Project',
      image: project24,
      location: 'Abuja',
      desc: 'The project is aimed at empowering students in 20 schools across 5 area councils in Abuja with essential digital technology skills.	 ',
      req: 'Strong understanding of digital technology, Excellent communication skills, Patience, and The ability to work with students of varying ages and backgrounds. Prior teaching experience or experience working with youth is advantageous.',
      side: ' Cross-cultural experience, Weekend Hangout',
      hours: 'Monday to Thursday 10am to 4pm',
      duration: '2 weeks',
    },
    {
      title: 'Skillify',
      image: project25,
      location: 'Port Harcourt',
      desc: 'This project aims to provide children with holistic learning experiences by focusing on teaching craft and handy skills. The initiative seeks to enhance creativity and practical knowledge, giving children hands-on experience in various crafts. By integrating craft education into the curriculum, the project aims to foster a love for learning and develop practical skills. ',
      req: 'Passionate about working with children, adept in communication, and equipped with transferable skills including knitting, needlework, baking, hairdressing, arts, crafts, and more.',
      side: ' Cross-cultural experience',
      hours: '3 Weekdays',
      duration: '2 weeks',
    },
    {
      title: 'Green Initiative',
      image: project26,
      location: 'Ilorin',
      desc: 'The project  aims at promoting  sustainable practices like  plastic recycling, and educating the communities on climate change. ',
      req: 'Passionate about climate and environment, Have digital skills like photography and soft skills like public speaking',
      side: ' Cross-cultural experience',
      hours: 'Flexible',
      duration: '2 weeks',
    },
    {
      title: 'Empower Together',
      image: project27,
      location: 'Ibadan',
      desc: 'This project aims to leverage on the skills and dedication of volunteers to support educational  initiatives for children, provide financial aid through sponsors and donations and meet the basic needs of underprivileged communities. With this project, volunteers contribute towards the NGO cause of empowering children, youth and the community at large ',
      req: 'Passionate about empowerment initiatives, committed, Willing to learn and participate.Should have basic skills such as beginner-level social media management. ',
      side: ' Cross-cultural experience, Hangouts with AiI members. Certificate of participation',
      hours:
        '3 weekdays and Saturday(for outreach and time is flexible); 9am to 3pm',
      duration: '2 weeks',
    },
    {
      title: 'Skill Up',
      image: project28,
      location: 'Enugu',
      desc: 'The project aims to impact young people by providing them with hard skills trainings (such as baking, photography, fashion designing, etc) needed to qualify for a decent job, and career guidance.',
      req: 'Excellent communication skills, Possess transferable skills such as sewing, photography, hair dressing, baking, etc ',
      side: ' Cross-cultural experience. Certificate of participation.',
      hours: 'Tuesday to Friday 10am - 4pm,',
      duration: '2 weeks',
    },
    {
      title: 'One Skilled Girl, One Smart Village',
      image: project1,
      location: 'Abuja',
      desc: 'The project aims to increase the number of empowered girls/women, aged 13-25, by empowering them with relevant vocational and soft skills, within underserved communities like IDP Camps in Nigeria to improve access to decent employment and building sustainable pathways for them in their immediate communities.The project highlights some common goals with SDG 1 (No poverty), SDG 4 (Quality education), and SDG 10 (Reduced inequalities).',
      req: 'Strong communication and interpersonal skills and lastly a CV to know their strenghths and background.Passion for community development and female empowerment. Willingness to work in field locations (IDP Camps). Ability to engage and mentor young women. Team player with an ability to work in a fast-paced environment. Experience in teaching, training, or social outreach (preferred but not required).',
      side: ' Cross-cultural experience. Certificate of participation.',
      hours: 'Monday, Tuesday, Thursday, Friday, and Saturday.  9:30 AM - 3:00 PM.',
      duration: '2 weeks',
    },
    {
      title: 'Bank 200',
      image: project2,
      location: 'Lagos',
      desc: 'Non-governmental organization that Advocate against sexual violences and child trafficking, we run a community based project,  Educational initiatives, Workshops, and we offer support services for survivors. They have a  community Cloth Bank called Bank 200. The  main sdgs focus is goal 16',
      side: ' Cross-cultural experience',
      hours: '3 Weekdays',
      duration: '2 weeks',
    },
    {
      title: 'JusticeHub',
      image: project3,
      location: 'Ilorin',
      desc: 'The EP supports lawyers and ensure smooth day-to-day operations. Key responsibilities include managing schedules, organizing case files, handling client communications, coordinating meetings, and maintaining records.',
      req: 'Strong communication skills, readiness to work, have a background in law.',
      side: ' Cross-cultural experience. Certificate of participation.',
      hours: 'Monday to Friday',
      duration: '2 weeks',
    },
    {
      title: 'Beyond Borders',
      image: project4,
      location: 'Jos',
      desc: 'Volunteers will include contributing to the growth of the organization by arranging books, ensuring proper categorization, and distributing them to beneficiaries. You will also document and track books that are borrowed or returned, assist with client inquiries, and provide customer support to ensure smooth operations.',
      req: '-Leadership skills ,Strong communication , organization skills and interpersonal skills and lastly a readiness to work.',
      side: ' Cross-cultural experience, Hangouts with AiI members. Certificate of participation',
      duration: '2 weeks',
    },
    {
      title: 'Glorious Stars',
      image: project7,
      location: 'Ilorin',
      desc: 'The EP guides students through hands-on workshops on using Google tools like Docs, Slides, Sheets, Forms, Calendar, Drive, and Keep, teaching them practical skills such as collaboration, organization, and data management. By creating documents, presentations, surveys, and schedules, students learn essential digital skills that enhance productivity and teamwork.',
      req: 'Leadership skills, communication skills, being conversant with google tools',
      side: 'Leadership experience, Certificate of Participation.',
      hours: 'Mondays - Fridays',
      duration: '2 weeks',
    },
    {
      title: 'Green Minds',
      image: project7,
      location: 'Abeokuta',
      desc: 'The EP will facilitate training sessions for young people and increase their participation in decision making processes related to climate change to ensure creating a sustainable future in the face of climate change while addressing local environmental challenges, improving biodiversity, reducing carbon footprints and creating more sustainable communities. the EP will also be facilitaing hands-on session, using recycled waste to create art or other pieces that promote sustainability.',
      req: 'Ability to teach, passionate about climate change and sustainable practices like waste recycling. The project also requires the volunteer to be willing to come up with creative designs and bring it to life using recycled materials',
      side: 'Cross cultural experience and lots of fun',
      hours: '3 weekdays',
      duration: '2 weeks',
    },
  ];

  const lcData = [
    { state: 'All', lc: 'All' },
    { state: 'Ogun', lc: 'Abeokuta' },
    { state: 'FCT', lc: 'Abuja' },
    { state: 'Ondo', lc: 'Akure' },
    { state: 'Edo', lc: 'Benin' },
    { state: 'Benue', lc: 'Makurdi' },
    { state: 'Cross River', lc: 'Calabar' },
    { state: 'Enugu', lc: 'Enugu' },
    { state: 'Oyo', lc: 'Ibadan' },
    { state: 'Osun', lc: 'Ife' },
    { state: 'Kwara', lc: 'Ilorin' },
    { state: 'Plateau', lc: 'Jos' },
    { state: 'Kano', lc: 'Kano' },
    { state: 'Lagos', lc: 'Lagos' },
    { state: 'Rivers', lc: 'Port Harcourt' },
  ];

  const [showFilter, setShowFilter] = useState(false);
  const [selectedState, setSelectedState] = useState(false);
  // const [selected, setSelected] = useState('');
  const [showPopup, setShowPopup] = useState(null);
  const [filteredProjects, setFilteredProjects] = useState(projects);
  const [showAllProjects, setShowAllProjects] = useState(false);

  const handleFilterClick = () => {
    setShowFilter((prev) => !prev);
  };

  const handleStateSelection = (state) => {
    // If the same state is clicked again, reset filter
    if (state === selectedState || state === "Any") {
      setSelectedState('');
      setFilteredProjects(projects);
      setShowFilter(false);
      return;
    }

    setSelectedState(state);
    setShowFilter(false);

    // Find the LC (city) for the selected state
    const selectedLC = lcData.find((lc) => lc.state === state)?.lc;

    const filtered = projects.filter(
      (project) =>
        project.location.trim().toLowerCase() ===
        selectedLC.trim().toLowerCase()
    );

    setFilteredProjects(filtered);
  };

  const displayedProjects = showAllProjects
    ? filteredProjects.length > 0
      ? filteredProjects
      : projects
    : (filteredProjects.length > 0 ? filteredProjects : projects).slice(0, 6);

  // Function to close the modal
  const handleCloseModal = () => {
    setShowPopup(null);
  };

  return (
    <div className="py-12 bg-[#f4faf5]">
      <div className="relative w-[90%] sm:w-[80%] md:w-[50%] xl:w-[30%] mx-auto">
        <div
          className="flex items-center justify-between border border-[#08841B] bg-white py-5 pl-[11px] pr-[26px] rounded-[50px] cursor-pointer"
          onClick={handleFilterClick}
        >
          <div className="bg-[#08841B] rounded-full flex items-center justify-center p-3">
            <img src={search} alt="search icon" className="w-[18px] h-[18px]" />
          </div>
          <p className="text-[#A8A8A8] text-[18px]">
            Search According to Location
          </p>
          <div>
            <img
              src={downCaret}
              alt="down arrow"
              className={`w-6 transition-transform ${
                showFilter ? 'rotate-180' : ''
              }`}
            />
          </div>
        </div>

        {/* Filter Dropdown */}
        {showFilter && (
          <div className="absolute left-0 w-full bg-white border mt-2 rounded-lg shadow-lg z-10 border-[#08841B] p-4">
            {lcData.map((lc, index) => (
              <div
                key={index}
                className={`px-4 py-2 mb-3 bg-[#F1FFF3] hover:bg-[#08841B] focus:bg-[#08841B] cursor-pointer text-center rounded-[15px] ${
                  selectedState === lc.state ? 'bg-[#08841B]' : 'bg-[#F1FFF3]'
                }`}
                onClick={() => handleStateSelection(lc.state)}
              >
                {lc.lc}
              </div>
            ))}
          </div>
        )}
      </div>

      <div className={classes.container}>
        {displayedProjects.length > 0 ? (
          displayedProjects.map((data, i) => (
            <div key={i} className={classes.detailsContainer}>
              <div className="flex flex-col text-black items-center justify-center border border-[#08841B] bg-[#F9F9F9] gap-8 pt-8 min-h-[400px]">
                {/* Title & Location */}
                <div className="text-black text-center">
                  <h3 className="font-bold text-xl">{data.title}</h3>
                  <p className="font-light text-xl">{data.location}</p>
                </div>

                {/* Background Image Section */}
                <div
                  className="relative h-[280px] bg-cover bg-center flex items-center justify-center rounded-[20px] mt-3 mb-1 mx-auto w-[97%]"
                  style={{ backgroundImage: `url(${data.image})` }}
                >
                  {/* Clickable Details Text */}
                  <div className="flex gap-2 items-center justify-center bg-white px-4 py-2 bg-opacity-80 rounded-lg cursor-pointer">
                    <p
                      className="text-black text-base"
                      onClick={() => setShowPopup(data)}
                    >
                      Details
                    </p>
                    <img src={rightArrow} alt="right arrow" />
                  </div>
                </div>
              </div>

              {/* {selected === data?.title && (
                <div className={classes.detailsBlock}>
                  <p>
                    <span className={classes.detailsText}>Location: </span>
                    {data?.location}
                  </p>
                  <p>
                    <span className={classes.detailsText}>
                      Project Description:
                    </span>
                    <br />
                    {data?.desc}
                  </p>
                  <p>
                    <span className={classes.detailsText}>
                      Project Requirements:
                    </span>
                    <br />
                    {data?.req}
                  </p>
                  <p>
                    <span className={classes.detailsText}>
                      Side Attractions:
                    </span>{' '}
                    <br />
                    {data?.side}
                  </p>
                  <p>
                    <span className={classes.detailsText}>Working Hours: </span>
                    {data?.hours}
                  </p>
                  <p>
                    <span className={classes.detailsText}>Duration: </span>
                    {data?.duration}
                  </p>
                </div>
              )} */}
            </div>
          ))
        ) : (
          <p className="text-center text-gray-500 mt-5">No projects found.</p>
        )}
      </div>
      {!showAllProjects && displayedProjects.length < projects.length && (
        <div
          className="flex items-center justify-center bg-[#00C16E] border border-black text-white rounded-[56px] py-4 mx-auto cursor-pointer w-[80%] sm:w-[60%] md:w-[25%] lg:w-[18%] xl:w-[15%] gap-4"
          onClick={() => setShowAllProjects((prev) => !prev)}
        >
          <p> See More</p>
          <img src={arrow} alt="slanted arrow" className="w-3 h-3" />
        </div>
      )}
      {/* Project Modal */}
      {showPopup && (
        <ProjectModal 
          isOpen={!!showPopup} 
          onClose={handleCloseModal} 
          project={showPopup} 
        />
      )}
    </div>
  );
};

export default NvProjectsPageProjects;
